import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatTableDate', value => {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
    }
});
